import { useEffect, useRef, useState } from 'react';
import useCallbackAsync from './useCallbackAsync';
import { AxiosResponse } from 'axios';

type useCacheFetchProps<T> = {
  init?: T;
  resetCache?: any[];
  onReset?: () => void;
  fetchData: () => Promise<AxiosResponse<T>>;
};

export default function useCacheFetch<T>({
  init = undefined,
  resetCache = [],
  onReset,
  fetchData,
}: useCacheFetchProps<T>) {
  const [data, setData] = useState<T>(init);

  const isFetched = useRef(false);

  const [fetch, isLoading] = useCallbackAsync(async () => {
    if (!isFetched.current) {
      isFetched.current = true;

      const { data } = await fetchData();

      setData(data);
    }
  }, false);

  useEffect(() => {
    isFetched.current = false;
    setData(init);
    onReset?.();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...resetCache, init]);

  return { data, isLoading, fetch };
}
